export default "__VITE_ASSET__DQ7eMxN9__"